import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PatientDialogDataModel} from '../../modules/patient/patient-dialog-data.model';
import {Globals} from '../../globals';

@Component({
  selector: 'app-duplicate-patient-found-dialog',
  templateUrl: './duplicate-patient-found-dialog.component.html',
  styleUrls: ['./duplicate-patient-found-dialog.component.scss']
})
export class DuplicatePatientFoundDialogComponent implements OnInit {

  ssNumEntered: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PatientDialogDataModel,
    public dialogRef: MatDialogRef<DuplicatePatientFoundDialogComponent>,
    private globals: Globals
  ) { }

  ngOnInit(): void {
    if (this.data.ThePatient.dataContact.GovermentIdentificationNo2) {
      this.ssNumEntered = true;
    }
  }

  getFormattedDateString(date: Date) {
    const date1 = new Date(date);
    const dateStr = date1.toDateString();
    return dateStr;
  }

  close(isCloseParent: boolean = false) {
    this.dialogRef.close(null);
  }

  selectPatient() {
    this.globals.ThePatient = this.data.ThePatient;
    this.globals.currentPatientId = this.data.ThePatient.PatientId;
    this.dialogRef.close(this.data.ThePatient);
  }
}
